import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppEvents } from 'src/app/app.config/app-events';
import { ConstantesApp } from 'src/app/app.config/constantes-app';
import { Cliente } from 'src/app/app.domain.models/cliente';
import { CuestionarioSaludColectivo } from 'src/app/app.domain.models/cuestionario-salud-colectivo';
import { Poliza } from 'src/app/app.domain.models/poliza';
import { CuestionarioSaludColectivoApiService } from 'src/app/app.domain.services/cuestionario-salud-colectivo.api.service';
import { FirmaOperacionService } from 'src/app/app.domain.services/operacion.service';
import { PolizaApiService } from 'src/app/app.modules/individual/domain.services/poliza.api.service';
import { EventBrokerService } from 'src/app/core.services/event-broker.service';
import { SesionService } from 'src/app/core.services/sesion.service';
import { Utilidades } from 'src/app/core.utilidades/utilidades';

@Component({
    selector: 'app-preguntas-colectivo',
    templateUrl: './preguntas-colectivo.component.html',
    styleUrls: ['./preguntas-colectivo.component.scss'],
})
export class PreguntasColectivoComponent implements OnInit {
    hospital: boolean | null = null;
    quedoBien: boolean = true;
    enfermedad: boolean | null = null;
    defecto: boolean | null = null;
    tensionNormal: boolean | null = null;
    conduceMotocicleta: boolean | null = null;
    practicaDeporte: boolean | null = null;

    disableBtnBackPreguntas: boolean = false;
    disableBtnNextPreguntas: boolean = false;

    mensajeValidacionForm: string = '';

    cliente!: Cliente;
    poliza!: Poliza;
    cuestionarioSaludColectivo!: CuestionarioSaludColectivo;

    formTratamientoHospital: FormGroup;
    formPadeceEnfermedadDefecto: FormGroup;
    formEstadoPesoAltura: FormGroup;
    formTensionNormalMotocicleta: FormGroup;
    formPracticaDeporte: FormGroup;
    formulario: string = "preguntas-colectivo";

    pasoActual: number = 1;
    totalPasos: number = 5;
    barraProgreso: number[];

    constructor(
        private router: Router,
        private sesion: SesionService,
        private translateService: TranslateService,
        private toastr: ToastrService,
        private eventService: EventBrokerService,
        private cuestionarioSaludApiService: CuestionarioSaludColectivoApiService,
        private operacionService: FirmaOperacionService,
        private route: ActivatedRoute,
        private polizaService: PolizaApiService,
    ) {
        this.cuestionarioSaludColectivo = new CuestionarioSaludColectivo();

        this.hospital = this.cuestionarioSaludColectivo?.hospitalizadoSiNo;
        this.quedoBien = this.cuestionarioSaludColectivo?.hospitalizadoQuedoBienSiNo;

        this.enfermedad = this.cuestionarioSaludColectivo?.enfermedadSiNo;
        this.defecto = this.cuestionarioSaludColectivo?.defectoSiNo;

        this.tensionNormal = this.cuestionarioSaludColectivo?.tensionNormalSiNo;

        this.conduceMotocicleta = this.cuestionarioSaludColectivo?.motocicletaSiNo;

        this.practicaDeporte = this.cuestionarioSaludColectivo?.deporteSiNo;

        this.formTratamientoHospital = new FormGroup({
            causaHospital: new FormControl({ value: this.cuestionarioSaludColectivo?.hospitalizadoDescripcion, disabled: !this.hospital }),
            cuandoHospital: new FormControl({ value: this.cuestionarioSaludColectivo?.hospitalizadoFecha, disabled: !this.hospital })
        });
        this.formPadeceEnfermedadDefecto = new FormGroup({
            nombreEnfermedad: new FormControl({ value: this.cuestionarioSaludColectivo?.enfermedadDescripcion, disabled: !this.enfermedad }),
            defectoDescripcion: new FormControl({ value: this.cuestionarioSaludColectivo?.defectoDescripcion, disabled: !this.enfermedad })
        });
        this.formEstadoPesoAltura = new FormGroup({
            peso: new FormControl(Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo?.peso) == 0 ? '' : Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo.peso), [Validators.required, Validators.pattern(ConstantesApp.REGEX_DOS_TRES_DIGITOS)]),
            altura: new FormControl(Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo?.altura) == 0 ? '' : Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo.altura), [Validators.required, Validators.pattern(ConstantesApp.REGEX_TRES_DIGITOS)])
        });
        this.formTensionNormalMotocicleta = new FormGroup({
            tensionMaxima: new FormControl(Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo?.tensionMaxima) == 0 ? '' : Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo.tensionMaxima), [Validators.required, Validators.pattern(ConstantesApp.REGEX_TENSION)]),
            tensionMinima: new FormControl(Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo?.tensionMinima) == 0 ? '' : Utilidades.transformPointToCommaDecimal(this.cuestionarioSaludColectivo.tensionMinima), [Validators.required, Validators.pattern(ConstantesApp.REGEX_TENSION)]),
            cilindrada: new FormControl({ value: this.cuestionarioSaludColectivo?.motocicletaCilindrada == 0 ? '' : this.cuestionarioSaludColectivo?.motocicletaCilindrada, disabled: !this.conduceMotocicleta }, [Validators.required, Validators.pattern(ConstantesApp.REGEX_DOS_CUATRO_DIGITOS)])
        });

        this.formPracticaDeporte = new FormGroup({ deporte: new FormControl({ value: this.cuestionarioSaludColectivo?.deporteDescripcion, disabled: !this.practicaDeporte }) });

        this.barraProgreso = Array.from({ length: this.totalPasos }, (_, index) => index);
    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            const tokenFirma = params.get('token');
            if (tokenFirma) {
                this.operacionService.obtenerDatosTokenCarritoAbandonado(tokenFirma).then((response: number) => {
                    this.polizaService.obtenerById(response).then((polizaResponse) => {
                        if (polizaResponse) {
                            this.poliza = polizaResponse;
                            this.cliente = this.poliza.cliente;
                            this.sesion.setCliente(this.cliente);
                            this.sesion.setPoliza(this.poliza);
                            this.comprobarPolizaSesion();
                        }
                    });
                });
            } else {
                this.cliente = this.sesion.getCliente();
                this.poliza = this.sesion.getPoliza();
                this.comprobarPolizaSesion();
            }
        });
    }

    comprobarPolizaSesion() {
        if (!this.sesion.getPoliza()?.id) {
            this.router.navigate([ConstantesApp.PATH_FORBIDDEN]);
        } else {
            this.poliza.ultimaPantalla = ConstantesApp.PATH_COLECTIVOS_4_PREGUNTAS_COLECTIVOS;
            this.eventService.publishEvent(AppEvents.actualizarUltimaAccion, this.poliza);
            this.eventService.publishEvent(AppEvents.actualizarColectivo, this.poliza.colectivo);
        }
    }

    isCurrentStep(step: number): boolean {
        return this.pasoActual === step;
    }

    goToNextStep(): void {
        if (this.pasoActual < this.totalPasos) {
            this.pasoActual++;
        }
    }

    goToPreviousStep(): void {
        if (this.pasoActual > 1) {
            this.pasoActual--;
        }
    }

    get getFormTrataHospital(): { [key: string]: AbstractControl } { return this.formTratamientoHospital.controls; }
    get getFormPadeceEnfermedadDefecto(): { [key: string]: AbstractControl } { return this.formPadeceEnfermedadDefecto.controls; }
    get getFormEstadoPesoAltura(): { [key: string]: AbstractControl } { return this.formEstadoPesoAltura.controls; }
    get getFormTensionNormalMotocicleta(): { [key: string]: AbstractControl } { return this.formTensionNormalMotocicleta.controls; }
    get getFormPracticaDeporte(): { [key: string]: AbstractControl } { return this.formPracticaDeporte.controls; }

    togglePracticaDeporte(value: boolean) {
        this.practicaDeporte = value;
        this.formPracticaDeporte.patchValue({
            deporte: value ? this.cuestionarioSaludColectivo?.deporteDescripcion : ''
        });
        if (value) {
            this.formPracticaDeporte.controls['deporte'].enable();
            this.formPracticaDeporte.controls["deporte"].setValidators([Validators.required, Validators.maxLength(20)]);
        } else {
            this.formPracticaDeporte.controls['deporte'].setValue('');
            this.formPracticaDeporte.controls['deporte'].disable();
            this.formPracticaDeporte.controls["deporte"].clearValidators();
        }
        this.formPracticaDeporte.controls["deporte"].updateValueAndValidity();
    }

    toggleConduceMotocicleta(value: boolean) {
        this.conduceMotocicleta = value;
        this.formTensionNormalMotocicleta.patchValue({
            cilindrada: (value && this.cuestionarioSaludColectivo?.motocicletaCilindrada > 0) ? this.cuestionarioSaludColectivo?.motocicletaCilindrada : ''
        });
        if (value) {
            this.formTensionNormalMotocicleta.controls['cilindrada'].enable();
            this.formTensionNormalMotocicleta.controls["cilindrada"].setValidators([Validators.required, Validators.pattern(ConstantesApp.REGEX_DOS_CUATRO_DIGITOS)]);
        } else {
            this.formTensionNormalMotocicleta.controls['cilindrada'].setValue('');
            this.formTensionNormalMotocicleta.controls['cilindrada'].disable();
            this.formTensionNormalMotocicleta.controls["cilindrada"].clearValidators();
        }
        this.formTensionNormalMotocicleta.controls["cilindrada"].updateValueAndValidity();
    }

    getError(data: any) {
        let transMessageError = Utilidades.obtenerErrorFormControl(data, this.formulario);
        if (transMessageError != "") return this.translateService.instant(transMessageError);
        return "";
    }

    toggleTensionNormal(value: boolean) {
        this.tensionNormal = value;
    }

    toggleEnfermedad(value: boolean) {
        this.enfermedad = value;
        this.formPadeceEnfermedadDefecto.patchValue({
            nombreEnfermedad: value ? this.cuestionarioSaludColectivo?.enfermedadDescripcion : ''
        });
        if (value) {
            this.formPadeceEnfermedadDefecto.controls['nombreEnfermedad'].enable();
            this.formPadeceEnfermedadDefecto.controls["nombreEnfermedad"].setValidators([Validators.required, Validators.maxLength(35)]);
        } else {
            this.formPadeceEnfermedadDefecto.controls['nombreEnfermedad'].setValue('');
            this.formPadeceEnfermedadDefecto.controls['nombreEnfermedad'].disable();
            this.formPadeceEnfermedadDefecto.controls["nombreEnfermedad"].clearValidators();
        }
        this.formPadeceEnfermedadDefecto.controls["nombreEnfermedad"].updateValueAndValidity();
    }

    toggleDefectoFisico(value: boolean) {
        this.defecto = value;
        this.formPadeceEnfermedadDefecto.patchValue({
            defectoDescripcion: value ? this.cuestionarioSaludColectivo?.defectoDescripcion : ''
        });
        if (value) {
            this.formPadeceEnfermedadDefecto.controls['defectoDescripcion'].enable();
            this.formPadeceEnfermedadDefecto.controls["defectoDescripcion"].setValidators([Validators.required, Validators.maxLength(67)]);
        } else {
            this.formPadeceEnfermedadDefecto.controls['defectoDescripcion'].setValue('');
            this.formPadeceEnfermedadDefecto.controls['defectoDescripcion'].disable();
            this.formPadeceEnfermedadDefecto.controls["defectoDescripcion"].clearValidators();
        }
        this.formPadeceEnfermedadDefecto.controls["defectoDescripcion"].updateValueAndValidity();
    }

    toggleHospital(value: boolean): void {
        this.hospital = value;
        this.formTratamientoHospital.reset({
            causaHospital: this.cuestionarioSaludColectivo?.hospitalizadoDescripcion,
            cuandoHospital: this.cuestionarioSaludColectivo?.hospitalizadoFecha
        });
        if (value) {
            this.formTratamientoHospital.controls['causaHospital'].enable();
            this.formTratamientoHospital.controls['cuandoHospital'].enable();
            this.formTratamientoHospital.controls['causaHospital'].setValidators([Validators.required, Validators.maxLength(35)]);
            this.formTratamientoHospital.controls['cuandoHospital'].setValidators([Validators.required, Validators.maxLength(23)]);
        } else {
            this.formTratamientoHospital.controls['causaHospital'].setValue('');
            this.formTratamientoHospital.controls['cuandoHospital'].setValue('');
            this.formTratamientoHospital.controls['causaHospital'].disable();
            this.formTratamientoHospital.controls['cuandoHospital'].disable();
            this.formTratamientoHospital.controls['causaHospital'].clearValidators();
            this.formTratamientoHospital.controls['cuandoHospital'].clearValidators();
        }
        this.formTratamientoHospital.controls['causaHospital'].updateValueAndValidity();
        this.formTratamientoHospital.controls['cuandoHospital'].updateValueAndValidity();
    }

    toggleQuedoBien(value: boolean) {
        this.quedoBien = value;
    }

    private allControlsValid(formGroup: FormGroup): boolean {
        let allValid = true;
        for (const controlName in formGroup.controls) {
            const control = formGroup.controls[controlName];
            if (control.enabled && control.invalid) {
                allValid = false;
                break;
            }
        }
        return allValid;
    }

    preguntaLugarTratado() {
        if (this.allControlsValid(this.formTratamientoHospital)) {
            this.goToNextStep();
        } else {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formTratamientoHospital.markAllAsTouched();
        }
    }

    preguntaQueEnfermedadDefecto() {
        if (this.allControlsValid(this.formPadeceEnfermedadDefecto)) {
            this.goToNextStep();
        } else {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formPadeceEnfermedadDefecto.markAllAsTouched();
        }
    }

    preguntaPesoAltura() {
        if (this.allControlsValid(this.formEstadoPesoAltura)) {
            this.goToNextStep();
        } else {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formEstadoPesoAltura.markAllAsTouched();
        }
    }

    preguntaTensionNormalMotocicleta() {
        this.validateTensionFields();

        if (this.formTensionNormalMotocicleta.invalid) {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formTensionNormalMotocicleta.markAllAsTouched();
        } else {
            this.goToNextStep();
        }
    }

    validateTensionFields() {
        const tensionMaxima = this.formTensionNormalMotocicleta.get('tensionMaxima');
        const tensionMinima = this.formTensionNormalMotocicleta.get('tensionMinima');
        const maxVal = parseFloat(tensionMaxima?.value.replace(',', '.'));
        const minVal = parseFloat(tensionMinima?.value.replace(',', '.'));

        if (tensionMaxima?.hasError('tensionMinimaMayorQueMaxima')) {
            tensionMaxima.setErrors(null, { emitEvent: false });
        }
        if (tensionMinima?.hasError('tensionMinimaMayorQueMaxima')) {
            tensionMinima.setErrors(null, { emitEvent: false });
        }

        if (maxVal > 0 && minVal > 0 && maxVal <= minVal) {
            tensionMaxima!.setErrors({ tensionMinimaMayorQueMaxima: true }, { emitEvent: false });
            tensionMinima!.setErrors({ tensionMinimaMayorQueMaxima: true }, { emitEvent: false });
        }
    }


    preguntaDeporte() {
        if (this.allControlsValid(this.formPracticaDeporte)) {
            this.finalizar();
        } else {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formPracticaDeporte.markAllAsTouched();
        }
    }

    retroceder(): void {
        this.router.navigate([ConstantesApp.PATH_COLECTIVOS_2_VER_PRECIO]);
        // this.router.navigate([ConstantesApp.PATH_COLECTIVOS_1_CALCULAR_SEGURO + '/' + this.poliza.colectivo?.url]);
    }

    finalizar() {
        this.cuestionarioSaludColectivo.hospitalizadoSiNo = this.hospital!;
        this.cuestionarioSaludColectivo.hospitalizadoQuedoBienSiNo = this.quedoBien!;
        this.cuestionarioSaludColectivo.enfermedadSiNo = this.enfermedad!;
        this.cuestionarioSaludColectivo.defectoSiNo = this.defecto!;
        this.cuestionarioSaludColectivo.tensionNormalSiNo = this.tensionNormal!;
        this.cuestionarioSaludColectivo.motocicletaSiNo = this.conduceMotocicleta!;
        this.cuestionarioSaludColectivo.deporteSiNo = this.practicaDeporte!;

        this.cuestionarioSaludColectivo.hospitalizadoDescripcion = this.formTratamientoHospital.controls["causaHospital"].value!;
        this.cuestionarioSaludColectivo.hospitalizadoFecha = this.formTratamientoHospital.controls["cuandoHospital"].value!;
        this.cuestionarioSaludColectivo.enfermedadDescripcion = this.formPadeceEnfermedadDefecto.controls["nombreEnfermedad"].value;
        this.cuestionarioSaludColectivo.defectoDescripcion = this.formPadeceEnfermedadDefecto.controls["defectoDescripcion"].value;
        this.cuestionarioSaludColectivo.peso = Utilidades.transformCommaToPointDecimal(String(this.formEstadoPesoAltura.controls["peso"].value));
        this.cuestionarioSaludColectivo.altura = Utilidades.transformCommaToPointDecimal(String(this.formEstadoPesoAltura.controls["altura"].value));
        this.cuestionarioSaludColectivo.tensionMaxima = Utilidades.transformCommaToPointDecimal(String(this.formTensionNormalMotocicleta.controls["tensionMaxima"].value));
        this.cuestionarioSaludColectivo.tensionMinima = Utilidades.transformCommaToPointDecimal(String(this.formTensionNormalMotocicleta.controls["tensionMinima"].value));
        this.cuestionarioSaludColectivo.motocicletaCilindrada = parseInt(this.formTensionNormalMotocicleta.controls["cilindrada"].value);
        this.cuestionarioSaludColectivo.deporteDescripcion = this.formPracticaDeporte.controls["deporte"].value;

        if (this.allControlsValid(this.formPracticaDeporte)) {
            this.sesion.setCliente(this.cliente);
            this.sesion.setPoliza(this.poliza);
            this.cuestionarioSaludColectivo.cliente = this.cliente;
            this.cuestionarioSaludColectivo.poliza = this.poliza;

            this.cuestionarioSaludApiService.crear(this.cuestionarioSaludColectivo);

            this.router.navigateByUrl(ConstantesApp.PATH_COLECTIVOS_3_MEJOR_PRECIO);

        } else {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formPracticaDeporte.markAllAsTouched();
        }
    }
}
